// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fa2121d4","455":"8bb8fd79","977":"57220e15"}[chunkId] + ".chunk.js";
};